<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">게시판 관리</a> &gt; <strong>FAQ 등록</strong></div>
			<h2 class="h_sub">FAQ 등록 <span class="fs_regular">[보기&amp;수정]</span></h2>
		</div>

    <FaqManageCreateForm/>
  </div>
</template>

<script>
import FaqManageCreateForm from "@/components/admin/board/FaqManageCreateForm.vue"

export default {
  components: {
    FaqManageCreateForm
  }
}
</script>
<style lang="">
    
</style>